import script from "./SearchView.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__